import { render } from "./RightDblArrow.vue?vue&type=template&id=de2ed31a"
import script from "./RightDblArrow.vue?vue&type=script&lang=js"
export * from "./RightDblArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__